import React, { Component } from 'react';
import { Button, Popconfirm, Modal, Tabs, Icon, Popover, message, Spin, Select, Tooltip, InputNumber } from 'antd';
import TableC from '../../basicElement/TableC';
import SetCount from './components/SetCount';
import SortList from './components/SortList';
import Update from './components/Update';
import VisitStage from './components/VisitStage';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import { ConfigDesc } from './constants';
import '../css/style.less';
import Copy from './components/Copy';
import RelatedVisit from './components/RelatedVisit';
import CoefficientConfig from './components/CoefficientConfig';
import SearchInput from '../../common/SearchInput';
import { getMatchOption } from '../../shared/selectFn';

const { TabPane } = Tabs;
const Option = Select.Option;
const hasValue = value => (value || value === 0) ? true : false;

class NewVisitPeriodPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            panes: [],
            data: [],
            activeKey: '',
            chooseType: 'visitPeriodPlan',
            evaluateRecordId: '',
            canCopy: false,  //判断是否可以复制访视方案
            visitGroupingList: [], //关于复制访视方案的数据
            visitCountOption: [],
            visitCommentOption: [],
            categoryList: [],
            stageList: [],
            visitingTypeList: [],
        };
    }

    componentDidMount(){
        const { evaluateRecordId } = this.props;
        this.queryPlan(evaluateRecordId);
        this.queryCategory(evaluateRecordId);
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId } = nextProps;
        this.queryPlan(evaluateRecordId);
        this.queryCategory(evaluateRecordId);
    }

    queryPlan = (evaluateRecordId) => {
        if (!evaluateRecordId) {
            return
        }
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitGroupingList,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, datas = [] } = res;
                const panesData = [];
                (datas || []).map(el => {
                    panesData.push({
                        visitGroupingId: el.visitGroupingId,
                        visitGroupingName: el.visitGroupingName,
                    })
                });
                this.setState({
                    loading: false,
                    panes: panesData,
                    activeKey: String(datas[0].visitGroupingId),
                    evaluateRecordId,
                    canCopy: data.canCopy,
                    visitGroupingList: datas,
                }, () => {
                    this.loadData();
                    this.queryStage();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    // 查询访视类别
    queryCategory = (evaluateRecordId) => {
        if (!evaluateRecordId) {
            return
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitCategoryForAddVisit,
            data: { evaluateRecordId, limit: 99999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({ categoryList: res.datas });
            },
        });
    }

    // 查询访视阶段
    queryStage = () => {
        const { activeKey } = this.state;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitStageWithPeriod,
            data: { visitGroupingId: activeKey },
            dataType: 'json',
            doneResult: res => {
                this.setState({ stageList: res.visitStageList });
            },
        });
    }

    // 查询访视类型
    queryType = (visitCategory, index) => {
        const { activeKey } = this.state;
        const { evaluateRecordId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitingNameForAddVisit,
            data: { 
                visitGroupingId: activeKey,
                evaluateRecordId,
                visitCategory,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = this.state;
                data[index].visitingTypeList = res.datas;
                this.setState({ data });
            },
        });
    }

    //更新关于“复制访视方案”的数据
    updateCopyData = () => {
        const { evaluateRecordId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitGroupingList,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, datas = [] } = res;
                this.setState({
                    canCopy: data.canCopy,
                    visitGroupingList: datas,
                }, () => {
                    this.loadData();
                });
            }
        });
    }

    deletePlan = targetKey => {
        const { evaluateRecordId } = this.props;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.deleteVisitType,
            data: { visitGroupingId: targetKey },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.queryPlan(evaluateRecordId);
                });
            },
            errorResult: (() => {
                this.setState({ loading: false });
            }),
        });
    }

    loadData = () => {
        const { activeKey } = this.state;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitTypeList,
            data: {
                visitGroupingId: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                const { visitTypeList } = res.data || {};
                this.setState({
                    loading: false,
                    data: visitTypeList || [],
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    preDelete = (visitTypeId, index) => {
        if (visitTypeId) {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.deleteVisitType,
                data: {
                    visitTypeId,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.loadData();
                },
            });
        } else {
            const { data } = this.state;
            data.splice(index, 1);
            this.setState({ data });
        }
    }

    getColumns = () => {
        const { type, record } = this.props;
        const { talAuth, deptBoAuth, pmlAuth, pmAuth } = record;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '访视阶段',
            dataIndex: 'stageValue',
            key: 'stageValue',
            fixed: 'left',
            width: 120,
            render: (text, record, index) => {
                const { isEdit, visitStageId } = record;
                const { stageList } = this.state;
                const stageOption = stageList.map(el => <Option value={el.visitStageId}>{el.stageValue}</Option>);
                return isEdit ? <Select
                        allowClear
                        placeholder="请选择"
                        style={{ width: 100 }}
                        value={visitStageId}
                        onChange={value => this.handleChange(value, 'visitStageId', index)}
                    >
                        { stageOption }
                </Select> : text
            },
        }, {
            title: '访视周期',
            dataIndex: 'periodValue',
            key: 'periodValue',
            width: 120,
            render: (text, record, index) => {
                const { isEdit, visitPeriodId, visitStageId } = record;
                const { stageList } = this.state;
                const { visitPeriodList: periodList } = getMatchOption(stageList, 'visitStageId', visitStageId);
                const periodOption = (periodList || []).map(el => <Option value={el.visitPeriodId}>{el.periodValue}</Option>)
                return isEdit ? <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 100 }}
                        value={visitPeriodId}
                        onChange={value => this.handleChange(value, 'visitPeriodId', index)}
                    >
                        { periodOption }
                    </Select> : text
            },
        },  {
            title: '访视类别',
            dataIndex: 'visitCategory',
            key: 'visitCategory',
            width: 200,
            render: (text, record, index) => {
                const { isEdit } = record;
                const { categoryList } = this.state;
                const categoryOption = categoryList.map(el => <Option value={el.visitCategory}>
                    <Tooltip placement="right" title={el.visitCategory}>
                        <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{el.visitCategory}</span>
                    </Tooltip>
                </Option>);
                return isEdit ? <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{ width: 180 }}
                    value={text}
                    onChange={value => this.handleChange(value, 'visitCategory', index)}
                >
                    { categoryOption }
                </Select> : text
            }
        }, {
            title: '访视类型',
            dataIndex: 'visitingTypeShow',
            key: 'visitingTypeShow',
            width: 140,
            render: (text, record, index) => {
                const { isEdit, visitingTypeId, visitingTypeList = [] } = record;
                const visitingTypeOption = visitingTypeList.map(el => <Option value={el.visitingTypeId}>
                    <Tooltip placement="right" title={el.visitingTypeName}>
                        <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{el.visitingTypeName}</span>
                    </Tooltip>
                </Option>);
                return isEdit ? <Select
                        allowClear
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={visitingTypeId}
                        onChange={value => this.handleChange(value, 'visitingTypeId', index)}
                    >
                        {visitingTypeOption}
                    </Select> : text
            }
        }, {
            title: <span>访视工时<Tooltip placement="top" title="以口服，皮下类作为基础"><Icon type="exclamation-circle" style={{ marginLeft: 4, color: '#108ee9' }} /></Tooltip></span>,
            dataIndex: 'visitHour',
            key: 'visitHour',
            width: 80,
            render: (text, record, index) => {
                const { isEdit } = record;
                return isEdit ? <InputNumber
                        placeholder="请输入"
                        style={{ width: 60 }}
                        value={text}
                        onChange={value => this.handleChange(value, 'visitHour', index)}
                    >
                    </InputNumber> : text
            }
        }, {
            title: '访视次数',
            dataIndex: 'visitTypeName',
            key: 'visitTypeName',
            width: 80,
            render: (text, record, index) => {
                const { isEdit, visitTypeName } = record;
                const { visitCountOption, activeKey } = this.state;
                
                return isEdit ? <SearchInput
                        isEdit={true}
                        style={{ width: 60 }}
                        params={{ limit: 20, visitGroupingId: activeKey }}
                        url={API_URL.evaluate.queryNotUsedVisitName}
                        initValue={{ key: visitTypeName, label: visitTypeName }}
                        keyword='configValue'
                        dataSource={visitCountOption}
                        parseData={this.parseVisitCountData}
                        handleSelect={value => this.visitCountSelectChange(value, index)}
                        placeholder='输入名称检索'
                    /> : text
            }
        }, {
            title: '访视备注',
            dataIndex: 'visitComment',
            key: 'visitComment',
            width: 140,
            render: (text, record, index) => {
                const { isEdit, visitComment } = record;
                const { visitCommentOption } = this.state;
                return isEdit ? <SearchInput
                            isEdit={true}
                            style={{ width: 120 }}
                            params={{ type: 'VISIT_COMMENT' }}
                            url={API_URL.evaluate.queryConfigWithChildByType}
                            initValue={{ key: visitComment, label: visitComment }}
                            keyword='configValue'
                            filterOption={true}
                            dataSource={visitCommentOption}
                            parseData={this.parsevisitCommentData}
                            handleSelect={value => this.visitCommentSelectChange(value, index)}
                            placeholder='输入名称检索'
                        /> : text
            }
        }, {
            title: '次数',
            dataIndex: 'count',
            key: 'count',
            width: 80,
            render: (text, record, index) => {
                const { isEdit, count = 1 } = record;
                return isEdit ? <InputNumber
                        placeholder="请输入"
                        style={{ width: 60 }}
                        value={count}
                        onChange={value => this.handleChange(value, 'count', index)}
                    >
                    </InputNumber> : text
            }
        }];
        // columns.push({
        //     title: '对照基准',
        //     dataIndex: 'referenceVisitTypeName',
        //     key: 'referenceVisitTypeName',
        //     width: 100,
        // }, {
        //     title: '访视时间点',
        //     dataIndex: 'visitTypeWindowDay',
        //     key: 'visitTypeWindowDay',
        //     width: 100,
        // }, {
        //     title: '访视窗口',
        //     dataIndex: 'visitTypeWindowInfo',
        //     key: 'visitTypeWindowInfo',
        //     width: 100,
        // });
        if (type !== 'view') {
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 260,
                render: (text, record, index) => {
                    const { visitTypeId, isEdit } = record;
                    const isNew = isEdit && !visitTypeId; // “添加访视”新增的行未保存，设置次数/关联访视次数需基于已保存记录
                    return (
                        <span>
                            {
                                isEdit ? <a onClick={() => this.save(record, index)}>保存</a> : <a onClick={() => this.update('edit', index)}>修改</a>
                            }
                            <span className="ant-divider" />
                            <Popconfirm
                                title="确定要删除吗?"
                                onConfirm={() => this.preDelete(visitTypeId, index)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <a >删除</a>
                            </Popconfirm>
                            {
                                !isNew && <span>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.setCount(record)}>设置次数</a>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.setRelated(record)}>关联访视次数</a>
                                </span>
                            }
                        </span>
                    );
                },
            });
        }
        return columns;
    }

    visitCountSelectChange = (value, index) => {
        const { data } = this.state;
        if (value == undefined) {
            data[index].visitTypeName = undefined;
        } else {
            data[index].visitTypeName = value.key;
        }
        this.setState({ data });
    }


    parseVisitCountData = (res, value) => {
        if (res.visitingFrequencyList) {
            const data = (res.visitingFrequencyList || []).map(item => ({
                text: item.configValue,
                value: item.configValue,
            }));
            this.setState({ visitCountOption: data });
        } else {
            this.setState({ visitCountOption: [] });
        }
    }

    visitCommentSelectChange = (value, index) => {
        const { data } = this.state;
        if (value == undefined) {
            data[index].visitComment = undefined;
        } else {
            data[index].visitComment =  value.key;
        }
        this.setState({ data });
    }

    parsevisitCommentData = (res, value) => {
        if (res.list) {
            const data = (res.list || []).map(item => ({
                text: item.configureValue,
                value: item.configureValue,
            }));
            this.setState({ visitCommentOption: data });
        } else {
            this.setState({ visitCommentOption: [] });
        }
    }

    handleChange = (value, key, index) => {
        const { data } = this.state;
        switch (key) {
            case 'visitStageId': {
                data[index].visitStageId = value;
                data[index].visitPeriodId = undefined;
                break;
            }
            case 'visitCategory': {
                data[index].visitCategory = value;
                data[index].visitingTypeId = undefined;
                value && this.queryType(value, index);  // 查询访视类型
                break;
            }
            case 'visitingTypeId': {
                data[index].visitingTypeId = value;
                const list = (data[index].visitingTypeList || []).filter(el => el.visitingTypeId == value);
                data[index].visitHour = value ? list[0].visitHour : undefined;
                data[index].visitComment = value ? list[0].regularRemark : undefined;
                break;
            }
            default: {
                data[index][key] = value;
                break;
            }
        }
        this.setState({
            data,
        });
    }


    handleTabChange = activeKey => {
        this.setState({ activeKey }, () => {
            this.loadData();
            this.queryStage();
            const { visitGroupingList = [], canCopy } = this.state;
            const haveVisitStage = visitGroupingList.filter(el => el.visitGroupingId == activeKey)[0].haveVisitStage;
            if (canCopy && !haveVisitStage) {
                Modal.confirm({
                    iconType: 'question-circle',
                    title: <div style={{marginLeft: 42}}>是否需要复制访视方案？</div>,
                    onOk: () => {
                        this.copyRef.show(visitGroupingList, activeKey);
                    },
                });
            }
        });
    }

    sort = () => {
        this.sortRef.show();
    }

    addStage = () => {
        this.stageRef.show();
    }

    update = (type, index) => {
        const { data } = this.state;
        if (type === 'add') {
            data.push({
                isEdit: true,
            });
        } else {
            data[index].isEdit = true;
            this.queryType(data[index].visitCategory, index);
        }
        this.setState({ data, visitCountOption: [] });
    }

    save = (record, index) => {
        const { activeKey } = this.state;
        const {
            firstWindowSymbol,
            firstWindowValue,
            secondWindowSymbol, 
            secondWindowValue, 
            ...rest
        } = record;
        if (!rest.visitStageId) {
            return message.warning('阶段名称不能为空!');
        }
        if (!rest.visitCategory) {
            return message.warning('访视类别不能为空!');
        }
        if (!rest.visitingTypeId) {
            return message.warning('访视类型不能为空!');
        }
        if (!rest.visitStageId) {
            return message.warning('阶段名称不能为空!');
        }
        if (!rest.visitHour) {
            return message.warning('访视工时不能为空!');
        }
        if (!rest.visitTypeName) {
            return message.warning('访视次数不能为空!');
        }
        if (
            (hasValue(firstWindowValue) && !hasValue(secondWindowValue)) ||
            (!hasValue(firstWindowValue) && hasValue(secondWindowValue))
        ) {
            return message.warning('访视窗口必须成对填写，请填写上边界或下边界的值，可以填写0');
        }
        if (firstWindowValue || firstWindowValue === 0) {
            rest.visitTypeWindowFloor = Number(SymbolType[firstWindowSymbol] + firstWindowValue);
            rest.visitTypeWindowCeil = Number(SymbolType[secondWindowSymbol] + secondWindowValue);
            if (rest.visitTypeWindowFloor > rest.visitTypeWindowCeil) {
                return message.warning('访视窗口的第一项值不能大于第二项值');
            }
        }
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.addVisitType,
            data: {
                ...rest,
                visitGroupingId: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    setCount = record => {
        this.countRef.show(record);
    }

    setRelated = record => {
        const { evaluateRecordId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.getEvaluateCreateTimeVisit,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { invCreateTimeVisit, evaluateRecordCreateTime } = res;
                // evaluateRecordCreateTime < invCreateTimeVisit 时不允许关联
                if (evaluateRecordCreateTime && invCreateTimeVisit && evaluateRecordCreateTime < invCreateTimeVisit) {
                    message.warning(`只有${invCreateTimeVisit}后新生成的临床评估记录才可关联访视`);
                    return;
                }
                this.relatedRef.show(record);
            },
        });
    }

    openCoefficientConfig = () => {
        this.coefficientRef.show();
    }

    getContent = () => {
        const { data } = this.state;
        const { type, record } = this.props;
        const { talAuth, deptBoAuth } = record || {};
        const isClinicalUser = sessionStorage.isClinicalUser === 'true';
        return (
            <div>
                {type !== 'view' &&
                    <div className="filter-bar tar">
                        <Button type="primary" onClick={this.addStage}>添加阶段/周期</Button>
                        <Button type="primary" onClick={() => this.update('add')}>添加访视</Button>
                        <Button type="primary" onClick={this.sort}>排序调整</Button>
                        {(talAuth || deptBoAuth || isClinicalUser) && <Button type="primary" onClick={this.openCoefficientConfig}>方案系数设置</Button>}
                    </div>
                }
                <TableC
                    data={data}
                    scrollY={400}
                    columns={this.getColumns()}
                    className="visitPeriodPlan"
                    rowKey="visitTypeId"
                />
            </div>
        );
    }

    saveSessionStorage = () => {
        const { curSession } = localStorage;
        if (curSession) {
            const backSession = JSON.parse(curSession) || {};
            (Object.keys(backSession) || []).forEach(item => {
                sessionStorage[item] = backSession[item];
            },
            );
        }
    }

    render() {
        const { loading, panes, activeKey, data, evaluateRecordId } = this.state;
        const { record, type } = this.props;
        const isClinicalUser = sessionStorage.isClinicalUser === 'true';
        return (
            <div className="main plan-visitType">
                <div className="breadcrumb-bar tac">
                    <Popover placement="right" overlayClassName="propercent-pop" content={ConfigDesc}>
                        <div style={{ float: 'left' }}>
                            <Icon type="info-circle" style={{ color: '#5750c9', marginRight: 4 }} />
                            <a>配置说明</a>
                        </div>
                    </Popover>
                    {type === 'view' && isClinicalUser && <Button type="primary" size="small" style={{ float: 'left', marginLeft: 4 }} onClick={this.openCoefficientConfig}>方案系数设置</Button>}
                    <h2 className="title">访视周期计划</h2>
                </div>
                <Spin spinning={loading}>
                    <Tabs
                        type='card'
                        activeKey={activeKey}
                        onChange={this.handleTabChange}
                    >
                        {
                            panes.map(el => {
                                const { visitGroupingId, visitGroupingName } = el;
                                return (
                                    <TabPane
                                        key={visitGroupingId}
                                        tab={visitGroupingName}
                                    >
                                        {this.getContent()}
                                    </TabPane>
                                );
                            })
                        }
                    </Tabs>
                </Spin>
                <SetCount ref={el => this.countRef = el} loadData={this.loadData} />
                <VisitStage 
                    ref={el => this.stageRef = el} 
                    loadData={this.loadData} 
                    visitGroupingId={activeKey} 
                    updateCopyData={this.updateCopyData}
                    queryStage={this.queryStage}
                />
                <SortList ref={el => this.sortRef = el} loadData={this.loadData} visitGroupingId={activeKey} />
                <Update
                    ref={el => this.updateRef = el}
                    loadData={this.loadData}
                    visitGroupingId={activeKey}
                    data={data}
                    evaluateRecordId={evaluateRecordId}
                />
                <Copy
                    ref={el => this.copyRef = el}
                    updateCopyData={this.updateCopyData}
                />
                <RelatedVisit
                    ref={el => this.relatedRef = el}
                    loadData={this.loadData}
                    evaluateRecordId={evaluateRecordId}
                    visitGroupingId={activeKey}
                />
                <CoefficientConfig
                    ref={el => this.coefficientRef = el}
                    evaluateRecordId={evaluateRecordId}
                    record={record}
                    type={type}
                />
            </div>
        );
    }
}

export default NewVisitPeriodPlan;




// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitPeriodPlan/index.js